import { forwardRef, type HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import Lock from '@assets/img/icons/lock.svg?react';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const availableInfoVariant = cva('', {
  variants: {
    wrapper: {
      default: css.wrapperDefault,
    },
    icon: {
      default: css.iconDefault,
    },
    text: {
      default: css.textDefault,
    },
    req: {
      default: css.reqDefault,
    },
  },
});

interface AvailableInfoProps
  extends VariantProps<typeof availableInfoVariant>,
    HTMLAttributes<HTMLDivElement> {
  level: number;
}

const AvailableInfo = forwardRef<HTMLDivElement, AvailableInfoProps>(
  (
    {
      level,
      wrapper = 'default',
      icon = 'default',
      text = 'default',
      req = 'default',
      ...props
    },
    ref,
  ) => {
    const { t } = useTranslation();

    return (
      <div
        ref={ref}
        {...props}
        className={cn(props.className, availableInfoVariant({ wrapper }))}
      >
        <Lock className={availableInfoVariant({ icon })} />
        <span className={availableInfoVariant({ text })}>
          {t('Available at')}
        </span>
        <span
          className={availableInfoVariant({ req })}
        >{`Level ${level}`}</span>
      </div>
    );
  },
);

export { AvailableInfo };
